"use strict";
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenURI = exports.supportsInterface = exports.soldInWorldBySplit = exports.soldInWorldByNft = exports.soldInWorldByCollection = exports.mintWithTeam = exports.mintWithSellerAllowlist = exports.mint = exports.isSellerAllowed = exports.hasEditorRole = exports.hasAdminRole = exports.getWorldsMetadataDelegateAddress = exports.getWorldSplitTemplateAddress = exports.getWorldName = exports.getTrustedSignerAddress = exports.getPendingOwner = exports.getPaymentAddress = exports.getDefaultTakeRate = exports.getAssociationBySplitAddress = exports.getAssociationBySplit = exports.getAssociationByNft = exports.getAssociationByCollection = exports.getApprovedRouterAddresses = exports.eip712Domain = exports.addToWorldBySplitV2 = void 0;
exports.addToWorldBySplitV2 = {
    parseOutput: (output) => {
        return {
            /** split (address payable) */
            split: output[0],
        };
    },
};
exports.eip712Domain = {
    parseOutput: (output) => {
        return {
            /** fields (bytes1) */
            fields: output[0],
            /** name (string) */
            name: output[1],
            /** version (string) */
            version: output[2],
            /** chainId (uint256) */
            chainId: output[3],
            /** verifyingContract (address) */
            verifyingContract: output[4],
            /** salt (bytes32) */
            salt: output[5],
            /** extensions (uint256[]) */
            extensions: output[6],
        };
    },
};
exports.getApprovedRouterAddresses = {
    parseOutput: (output) => {
        return {
            /** routerA (address) */
            routerA: output[0],
            /** routerB (address) */
            routerB: output[1],
        };
    },
};
exports.getAssociationByCollection = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[1],
        };
    },
};
exports.getAssociationByNft = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[1],
        };
    },
};
exports.getAssociationBySplit = {
    parseOutput: (output) => {
        return {
            /** split (address payable) */
            split: output[0],
            /** worldId (uint256) */
            worldId: output[1],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[2],
        };
    },
};
exports.getAssociationBySplitAddress = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
            /** nftContract (address) */
            nftContract: output[1],
            /** seller (address) */
            seller: output[2],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[3],
        };
    },
};
exports.getDefaultTakeRate = {
    parseOutput: (output) => {
        return {
            /** defaultTakeRateInBasisPoints (uint16) */
            defaultTakeRateInBasisPoints: output[0],
        };
    },
};
exports.getPaymentAddress = {
    parseOutput: (output) => {
        return {
            /** worldPaymentAddress (address payable) */
            worldPaymentAddress: output[0],
        };
    },
};
exports.getPendingOwner = {
    parseOutput: (output) => {
        return {
            /** pendingOwner (address) */
            pendingOwner: output[0],
        };
    },
};
exports.getTrustedSignerAddress = {
    parseOutput: (output) => {
        return {
            /** signer (address) */
            signer: output[0],
        };
    },
};
exports.getWorldName = {
    parseOutput: (output) => {
        return {
            /** name (string) */
            name: output[0],
        };
    },
};
exports.getWorldSplitTemplateAddress = {
    parseOutput: (output) => {
        return {
            /** worldSplitTemplate (address) */
            worldSplitTemplate: output[0],
        };
    },
};
exports.getWorldsMetadataDelegateAddress = {
    parseOutput: (output) => {
        return {
            /** worldsMetadataDelegate (address) */
            worldsMetadataDelegate: output[0],
        };
    },
};
exports.hasAdminRole = {
    parseOutput: (output) => {
        return {
            /** hasRole (bool) */
            hasRole: output[0],
        };
    },
};
exports.hasEditorRole = {
    parseOutput: (output) => {
        return {
            /** hasRole (bool) */
            hasRole: output[0],
        };
    },
};
exports.isSellerAllowed = {
    parseOutput: (output) => {
        return {
            /** isAllowed (bool) */
            isAllowed: output[0],
        };
    },
};
exports.mint = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
        };
    },
};
exports.mintWithSellerAllowlist = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
        };
    },
};
exports.mintWithTeam = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
        };
    },
};
exports.soldInWorldByCollection = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
            /** worldPaymentAddress (address payable) */
            worldPaymentAddress: output[1],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[2],
        };
    },
};
exports.soldInWorldByNft = {
    parseOutput: (output) => {
        return {
            /** worldId (uint256) */
            worldId: output[0],
            /** worldPaymentAddress (address payable) */
            worldPaymentAddress: output[1],
            /** takeRateInBasisPoints (uint16) */
            takeRateInBasisPoints: output[2],
        };
    },
};
exports.soldInWorldBySplit = {
    parseOutput: (output) => {
        return {
            /** worldPaymentAddress (address payable) */
            worldPaymentAddress: output[0],
            /** curatorTakeInWei (uint256) */
            curatorTakeInWei: output[1],
        };
    },
};
exports.supportsInterface = {
    parseOutput: (output) => {
        return {
            /** isSupported (bool) */
            isSupported: output[0],
        };
    },
};
exports.tokenURI = {
    parseOutput: (output) => {
        return {
            /** uri (string) */
            uri: output[0],
        };
    },
};
//# sourceMappingURL=WorldsHelpers.generated.js.map